/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Subtract/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Subtract({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Subtract",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Subtract.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-gjNIO': alignSelf,'--mt-2-gjNIO': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-gjNIO': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-gjNIO': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-gjNIO': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-gjNIO': opacity,'--w-10-gjNIO': typeof width === 'number' ? `${width}px` : width,'--h-11-gjNIO': typeof height === 'number' ? `${height}px` : height,'--f-12-gjNIO': fill,'--a-7-gjNIO': isAnimated ? animation : "none",'--sd-8-gjNIO': isAnimated ? strokeDashoffset : 0,'--sd-9-gjNIO': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Subtract.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6 12A6 6 0 106 0a6 6 0 000 12zM3.429 5.357a.643.643 0 000 1.286H8.57a.643.643 0 000-1.286H3.43z"
 style={{'--f-12-gjNIO': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}